import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFpxControlComponent } from '@fpx/core';
import { Observable, Subject, Subscription, timer } from 'rxjs';

@Component({
  selector: 'fpx-timer',
  templateUrl: './fpx-timer.component.html',
  styleUrls: ['./fpx-timer.component.scss']
})
export class FpxTimerComponent implements OnInit {
  @Input() expireSec: number = 60; // in sec
  @Output() timeout = new EventEmitter<boolean>();
  @Input() startTimer: Subject<void>;

  private eventsSubscription: Subscription;
  countdown!: Subscription;
  countdownTime: number = 0;
  countdownTimeDisplayText: string = '';
  enableRensedOption: boolean = true;

  constructor() { }
  
  ngOnInit(): void {
    this.countdownTimeDisplayText = this._constructDisplayText(this.expireSec);
    this.startTimer.subscribe(
      () => {
        this._startCountdown();
      }
    );
  }

  ngOnDestroy() {
    if(this.eventsSubscription) this.eventsSubscription.unsubscribe();
  }

  private _startCountdown() {
    if (this.countdown) this.countdown.unsubscribe();
    this.countdownTime = this.expireSec;
    this.enableRensedOption = false;
    this.countdown = timer(0, 1000).subscribe((x) => {
      this.countdownTime = this.countdownTime - 1;
      this.countdownTimeDisplayText = this._constructDisplayText(this.countdownTime);
      if (this.countdownTime === 0) {
        this.countdown.unsubscribe();
        this.timeout.emit(true);
        this.enableRensedOption = true;
      }
    });
  }

  private _constructDisplayText(counterTime: number) {
    var m: any = Math.floor(counterTime / 60);
    var s: any = counterTime % 60;
    m = m < 10 ? '0' + m : m;
    s = s < 10 ? '0' + s : s;
    return m + ':' + s;
  }

}
